// utils/modelSearch.js - type-ahead filter for the product model list, plus a
// localStorage copy of the list so model choice keeps working offline.

const CACHE_KEY = 'product_models_cache';

// Lowercase, strip accents and surrounding whitespace so "Ünit" matches "unit".
export function normalizeSearch(s) {
  return String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

// Models whose name starts with the query come first, then models that merely
// contain it. Each group keeps the incoming (admin-curated) order.
// An empty query returns the full list.
export function filterModels(models, query) {
  const list = Array.isArray(models) ? models : [];
  const q = normalizeSearch(query);
  if (!q) return list;
  const starts = [];
  const contains = [];
  for (const m of list) {
    const name = normalizeSearch(m?.name);
    if (name.startsWith(q)) starts.push(m);
    else if (name.includes(q)) contains.push(m);
  }
  return starts.concat(contains);
}

export function readCachedModels() {
  try {
    const v = JSON.parse(localStorage.getItem(CACHE_KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export function writeCachedModels(models) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(models)); } catch { /* storage full or blocked */ }
}
